/**
 * Token persistence. This backend issues a single bearer access token (no
 * refresh token), so we persist just the access token + active company id.
 */
const ACCESS_KEY = 'distroops.access_token'
const REMEMBER_KEY = 'distroops.remember'
const COMPANY_KEY = 'distroops.active_company_id'
const IMP_OWNER_KEY = 'distroops.impersonation_owner_token'
const IMP_TENANT_KEY = 'distroops.impersonation_tenant_name'

export const tokenStorage = {
  getAccess(): string | null {
    return localStorage.getItem(ACCESS_KEY) ?? sessionStorage.getItem(ACCESS_KEY)
  },
  getCompanyId(): string | null {
    return localStorage.getItem(COMPANY_KEY)
  },
  set(access: string, remember = true): void {
    localStorage.setItem(REMEMBER_KEY, remember ? '1' : '0')
    // Avoid a stale copy in the other store.
    localStorage.removeItem(ACCESS_KEY)
    sessionStorage.removeItem(ACCESS_KEY)
    ;(remember ? localStorage : sessionStorage).setItem(ACCESS_KEY, access)
  },
  setCompanyId(id: number | string): void {
    localStorage.setItem(COMPANY_KEY, String(id))
  },
  clear(): void {
    localStorage.removeItem(ACCESS_KEY)
    sessionStorage.removeItem(ACCESS_KEY)
    localStorage.removeItem(COMPANY_KEY)
  },

  // ── Impersonation ────────────────────────────────────────────────
  /** Stash the owner's token before swapping to the tenant token. */
  beginImpersonation(ownerToken: string, tenantName: string): void {
    localStorage.setItem(IMP_OWNER_KEY, ownerToken)
    localStorage.setItem(IMP_TENANT_KEY, tenantName)
  },
  isImpersonating(): boolean {
    return localStorage.getItem(IMP_OWNER_KEY) !== null
  },
  getImpersonationTenant(): string | null {
    return localStorage.getItem(IMP_TENANT_KEY)
  },
  getImpersonationOwnerToken(): string | null {
    return localStorage.getItem(IMP_OWNER_KEY)
  },
  endImpersonation(): void {
    localStorage.removeItem(IMP_OWNER_KEY)
    localStorage.removeItem(IMP_TENANT_KEY)
  },
}
